import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface SelectOption {
  label: string
  value: string
}

export const useMonthOptions = () => {
  const { t, i18n } = useTranslation('common', { keyPrefix: 'components.month-filter-select' })

  return useMemo(() => {
    const options: SelectOption[] = [{ label: t('option.beginning-of-year'), value: 'BOY' }]

    const now = new Date()
    const currentMonth = now.getMonth()
    const currentYear = now.getFullYear()

    const monthFormatter = new Intl.DateTimeFormat(i18n.language, {
      month: 'long',
      year: 'numeric',
    })

    for (let m = 0; m <= currentMonth; m++) {
      const date = new Date(currentYear, m, 1)

      const monthName = monthFormatter.format(date)

      const label = monthName.charAt(0).toUpperCase() + monthName.slice(1)

      const monthValue = (m + 1).toString().padStart(2, '0')

      options.push({
        label,
        value: `${currentYear}-${monthValue}`,
      })
    }

    return options
  }, [t, i18n.language]) // Recalcule si la langue change
}
